/**
 * Utilidades para aplicar máscaras a campos de formulario
 */

/**
 * Aplica máscara de teléfono dominicano: (809) 123-4567
 */
export const maskPhone = (value) => {
	// Remover todo excepto números
	const numbers = value.replace(/\D/g, '');
	
	// Aplicar formato según la longitud
	if (numbers.length === 0) return '';
	if (numbers.length <= 3) return `(${numbers}`;
	if (numbers.length <= 6) return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
	return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
};

/**
 * Aplica máscara de cédula dominicana: 001-1234567-8
 */
export const maskCedula = (value) => {
	// Remover todo excepto números
	const numbers = value.replace(/\D/g, '');
	
	// Aplicar formato según la longitud
	if (numbers.length === 0) return '';
	if (numbers.length <= 3) return numbers;
	if (numbers.length <= 10) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
	return `${numbers.slice(0, 3)}-${numbers.slice(3, 10)}-${numbers.slice(10, 11)}`;
};

/**
 * Aplica máscara de RNC dominicano: 123-45678-9
 */
export const maskRNC = (value) => {
	// Remover todo excepto números
	const numbers = value.replace(/\D/g, '');
	
	// Aplicar formato según la longitud
	if (numbers.length === 0) return '';
	if (numbers.length <= 3) return numbers;
	if (numbers.length <= 8) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
	return `${numbers.slice(0, 3)}-${numbers.slice(3, 8)}-${numbers.slice(8, 9)}`;
};

/**
 * Remueve la máscara de un valor (solo números)
 */
export const unmask = (value) => {
	return value.replace(/\D/g, '');
};

